import { EnvelopeSimple, PhoneCall, MapPin, PaperPlaneTilt } from "@phosphor-icons/react";
import ContactForm from "@/components/ContactForm";
import { useBranding } from "@/contexts/BrandingContext";

export default function ContactSection() {
  const { branding } = useBranding();
  const email = branding?.contact_email || "info@conexusfoundation.org";
  const phone = branding?.contact_phone;
  const address = branding?.contact_address;

  return (
    <section className="bg-stone-950 py-16 sm:py-20 border-y border-stone-900/80" data-testid="contact-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col items-center text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-600/10 border border-emerald-700/30 mb-4">
            <PaperPlaneTilt size={14} weight="duotone" className="text-emerald-400" />
            <span className="text-[10px] uppercase tracking-[0.18em] text-emerald-300 font-heading font-semibold">Get in touch</span>
          </div>
          <h2 className="font-heading text-2xl sm:text-3xl font-bold text-white">We would love to hear from you</h2>
          <p className="text-sm text-stone-400 mt-3 max-w-xl font-body">
            Questions about our data, carbon-credit workflow, or a partnership idea? Reach out below and a team member will reply within two business days.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          <div className="lg:col-span-2 space-y-3">
            <div className="bg-stone-900 rounded-xl border border-stone-800 p-5 flex items-start gap-3">
              <EnvelopeSimple size={20} weight="duotone" className="text-emerald-400 shrink-0" />
              <div>
                <p className="text-[10px] text-stone-500 uppercase tracking-wider">Email</p>
                <a href={`mailto:${email}`} className="text-sm text-white hover:text-emerald-400 break-all">{email}</a>
              </div>
            </div>
            {phone && (
              <div className="bg-stone-900 rounded-xl border border-stone-800 p-5 flex items-start gap-3">
                <PhoneCall size={20} weight="duotone" className="text-emerald-400 shrink-0" />
                <div>
                  <p className="text-[10px] text-stone-500 uppercase tracking-wider">Phone</p>
                  <a href={`tel:${phone}`} className="text-sm text-white hover:text-emerald-400">{phone}</a>
                </div>
              </div>
            )}
            {address && (
              <div className="bg-stone-900 rounded-xl border border-stone-800 p-5 flex items-start gap-3">
                <MapPin size={20} weight="duotone" className="text-emerald-400 shrink-0" />
                <div>
                  <p className="text-[10px] text-stone-500 uppercase tracking-wider">Address</p>
                  <p className="text-sm text-stone-300 whitespace-pre-line">{address}</p>
                </div>
              </div>
            )}
          </div>
          <div className="lg:col-span-3">
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
}
